// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1adp5","content":"styles_content__2fDxh"};